import classnames from 'classnames';
import { range } from 'lodash-es';
import { FC } from 'react';
import type { GroupColor } from 'state/quotes/dashboard/tiles/tiles.model';
import styled from 'styled-components';

import { ColorItem } from './ColorItem';

const ColorSelectorContainer = styled.div`
  min-width: 200px;
`;

interface ColorSelectorProps {
  className?: string;
  selectedColor?: GroupColor;
  onColorSelected(color?: GroupColor): void;
}

export const ColorSelector: FC<ColorSelectorProps> = ({ selectedColor, className, onColorSelected }) => {
  const availableColors = range(0, 8) as GroupColor[];
  return (
    <ColorSelectorContainer className={classnames('d-flex flex-row justify-content-between', className)}>
      {availableColors.map(color => (
        <ColorItem key={color} color={color} onColorSelected={onColorSelected} active={color === selectedColor} />
      ))}
    </ColorSelectorContainer>
  );
};
